import { SALES_MULTIPLIER } from '../constants/config';

export function applySalesMultiplier(data, view, turnover) {
  if (view === "Sales" && turnover) {
    const multiplier = turnover * SALES_MULTIPLIER;
    return data.map(val => val * multiplier);
  }
  return data;
}
